import NiceModal, { useModal } from '@ebay/nice-modal-react';

// Import components
import { AntModal } from 'components/views/offer_configurator/components/common';

// Import types
import type { LastPaymentsRedirectUrl } from 'types/api/payments';

// Import hooks
import { useLastTransaction } from 'components/views/offer_configurator/hooks';

type Props = {
	payment: LastPaymentsRedirectUrl;
	setPacket: () => void;
};

export const LastPaymentModal = NiceModal.create(({ payment, setPacket }: Props) => {
	const { visible, remove } = useModal();
	const transaction = useLastTransaction(payment, 'packet');

	const cancelText = payment.payment_id ? 'button_cancel_and_start_new' : null;
	const confirmText = payment.redirect_url ? 'button_finish_last_purchase' : null;

	const handleConfirm = () => {
		transaction.onRetry();
		remove();
	};

	const handleCancel = () => {
		transaction.onCancel(setPacket);
		remove();
	};

	return (
		<AntModal
			namespace="transaction"
			title="modal_last_payment_title"
			description={{
				key: 'modal_last_payment_description',
				values: { title: transaction.title }
			}}
			cancelText={cancelText}
			confirmText={confirmText}
			visible={visible}
			onConfirm={handleConfirm}
			onCancel={handleCancel}
			closeModal={remove}
			closable
		/>
	);
});
